import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a50cd72"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon_button = _resolveComponent("oxd-icon-button")!
  const _component_oxd_text = _resolveComponent("oxd-text")!
  const _component_oxd_dropdown_menu = _resolveComponent("oxd-dropdown-menu")!

  return (_openBlock(), _createBlock(_component_oxd_dropdown_menu, {
    onClick: _ctx.noOp,
    class: "oxd-table-dropdown"
  }, {
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("li", {
          key: option.context,
          onClick: ($event: any) => (_ctx.onClick($event, option.context)),
          class: "oxd-table-dropdown-item"
        }, [
          _createVNode(_component_oxd_text, { tag: "p" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(option.label), 1)
            ]),
            _: 2
          }, 1024)
        ], 8, _hoisted_1))
      }), 128))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_oxd_icon_button, { name: "three-dots-vertical" })
    ]),
    _: 1
  }, 8, ["onClick"]))
}